import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { AuthLoading } from '@components/shared/AuthLoading'
import { useAuthentication } from '../context'

export const AuthCallback = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const { getExchangeAuthCode } = useAuthentication()

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const code = params.get('code')

    getExchangeAuthCode(code, navigate)
  }, [location])

  return <AuthLoading />
}
